import React from 'react';
import styles from './index.module.scss';
import cName from "classnames";
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

interface IProps {

}
export { getServerSideProps }
export default ({ navDetail }: any) => {
  const t = useTranslations();
  const router = useRouter()

  return (
    <PageLayout title={(
      <>
        <h1>{navDetail?.sub_title}</h1>
        <p style={{ fontWeight: 'normal' }}>{navDetail?.brief}</p>
      </>
    )}>
      <div className={styles.container}>
        {getHead(navDetail)}
        <i className={styles.bg}></i>
        <div className={styles.box}>
          <section className={styles.section1}>
            <h2>{t('visa.title1')}</h2>
            <img src="http://admin.ipbexpo.com/uploads/editor/20250707/792fed2bef600f677608b56192eed5c0.png" alt="" />
            <div className={cName([styles.info, router.locale === 'en' && styles.en])}>
              <div className={styles.left}>
                <h3>{t('visa.prepare')}</h3>
                <ul>
                  <li>{t('visa.prepareText.text1')}</li>
                  <li>{t('visa.prepareText.text2')}</li>
                  {
                    router.locale === 'en'
                      ? <li>Email: <a style={{ color: '#6354a2' }} href={`mailto:${t('visa.prepareText.text3')}`}>{t('visa.prepareText.text3')}</a></li>
                      : <li>{t('visa.prepareText.text3')}</li>
                  }
                  <li>{t('visa.prepareText.text4')}</li>
                </ul>
              </div>
              <div className={styles.right}>
                <h3>{t('visa.condition')}</h3>
                <ul>
                  <li>{t('visa.conditionText.text1')}</li>
                  <li>{t('visa.conditionText.text2')}</li>
                  <li>{t('visa.conditionText.text3')}</li>
                  <li>{t('visa.conditionText.text4')}</li>
                </ul>
                <a className={styles.btn} href="/docx/Invitation lettter template.docx" target='_blank'>
                  <img src="/image/pdf.png" alt="" />
                  <span>{t('visa.download')}</span>
                </a>
              </div>
            </div>
          </section>
          <section className={styles.section2}>
            <h2>{t('visa.title2')}</h2>
            <div className={styles.map}>
              <img src="/image/visa/icon-map.png" alt="" />
              <span>{t('visa.address')}</span>
            </div>
            <div className={styles.list}>
              <div className={styles.item}>
                <h3>
                  <img src="/image/visa/icon-1.png" alt="" />
                  <span>{t('visa.way1')}</span>
                </h3>
                <ul>
                  <li>{t('visa.way1Text.text1')}</li>
                  <li>{t('visa.way1Text.text2')}</li>
                  <li>{t('visa.way1Text.text3')}</li>
                </ul>
              </div>
              <div className={styles.item}>
                <h3>
                  <img src="/image/visa/icon-2.png" alt="" />
                  <span>{t('visa.way2')}</span>
                </h3>
                <ul>
                  <li>{t('visa.way2Text.text1')}</li>
                </ul>
              </div>
              <div className={styles.item}>
                <h3>
                  <img src="/image/visa/icon-3.png" alt="" />
                  <span>{t('visa.way3')}</span>
                </h3>
                <ul>
                  <li>{t('visa.way3Text.text1')}</li>
                  <li>{t('visa.way3Text.text2')}</li>
                  <li>{t('visa.way3Text.text3')}</li>
                  <li>{t('visa.way3Text.text4')}</li>
                </ul>
              </div>
              <div className={styles.item}>
                <h3>
                  <img src="/image/visa/icon-4.png" alt="" />
                  <span>{t('visa.way4')}</span>
                </h3>
                <ul>
                  <li>{t('visa.way4Text.text1')}</li>
                  <li>{t('visa.way4Text.text2')}</li>
                  <li>{t('visa.way4Text.text3')}</li>
                  <li>{t('visa.way4Text.text4')}</li>
                </ul>
              </div>
              <div className={styles.item}>
                <h3>
                  <img src="/image/visa/icon-5.png" alt="" />
                  <span>{t('visa.way5')}</span>
                </h3>
                <ul>
                  <li>{t('visa.way5Text.text1')}</li>
                  <li>{t('visa.way5Text.text2')}</li>
                  <li>{t('visa.way5Text.text3')}</li>
                </ul>
                <img className={styles.image} src="/image/visa/map.png" alt="" />
              </div>
            </div>
          </section>
        </div>
        <style global jsx>
          {
            `

            `
          }
        </style>
      </div>
    </PageLayout >
  );
};


